var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle",attrs:{"role":"bar"}},[_c('div',{staticClass:"e-loadholder"},[_c('div',{staticClass:"m-loader"},[_c('span',{staticClass:"e-text"},[_vm._v("Loading")])])]),_c('div',{attrs:{"id":"particleCanvas-Blue"}}),_c('div',{attrs:{"id":"particleCanvas-White"}})])
}]

export { render, staticRenderFns }